import request from '@/utils/request'


export function defaultAuthorization() {
  return "Basic BIuWtuqmi+2aNa7faKXYp8dJmlbWprQ+I20O6jzb3SyPe+WdizvO9lQ7hjarNEoSrTp4Nz3Biqp7lzb50mybQLNBqznK6D9QXvg/JJ6+0OauFXs0ZRrM69x/9D/JD9IXFAAGfaN/KxfHL+NJVA=="
}
// 用户登录
export function login(data) {
    return request({
      method: "post",
      url: "/authorization/api/auth/login",
      data: data,
      headers: {
        Authorization: defaultAuthorization()
      }
    })
}
// 获取验证码图片
export function getVerifyCode() {
  return request({
    method: "get",
    url: "/authorization/api/auth/verifyCode",
    headers: {
      Authorization: defaultAuthorization()
    }
  })
}
//注册
export function registerUser(data) {
  return request({
    method: "post",
    url: "/authorization/api/auth/registerUser",
    data: data,
    headers: {
      Authorization: defaultAuthorization()
    }
  })
}
//忘记密码
export function resetPassWord(data) {
  return request({
    method: "put",
    url: "/authorization/api/auth/user/reset",
    data: data,
    headers: {
      Authorization: defaultAuthorization()
    }
  })
}
// 获取短信验证码
export function sms(data) {
  return request({
    method: "post",
    url: "/authorization/api/auth/sms",
    headers: {
      Authorization: defaultAuthorization()
    },
    data:data
  })
}

// 获取用户信息
export function getUserInfo() {
  return request({
    method: "get",
    url: "/organization/api/user/userInfo"
  })
}

// 注销
export function removeUser() {
  return request({
    method: "delete",
    url: "/organization/api/remove/user"
  })
}
//退出登录
export function logout() {
  return request({
    method: "post",
    url: "/authorization/api/logout"
  })
}

// 白名单UKey登录 - 获取随机数
export function tygmLogin(data) {
  return request({
    method: "post",
    url: "/authorization/api/auth/tygmLogin",
    data: data,
    headers: {
      Authorization: defaultAuthorization()
    }
  })
}

// 白名单UKey登录 - 验证签名
export function yqWebVerifySign(data) {
  return request({
    method: "post",
    url: "/authorization/api/auth/yqWebVerifySign",
    data: data,
    headers: {
      Authorization: defaultAuthorization()
    }
  })
}